import React from "react";
import LandingCard from "../landingCard/LandingCard";
import "./Landing.css";
import { Grid } from "@mui/material";
import { useLoaderData, useNavigate } from "react-router-dom";


const LandingPage = () => {
  const navigate = useNavigate()
  const loaderData = useLoaderData()
  // Log loader data and current path for debugging route/loader issues
  console.log( 'LandingPage loaderData:', loaderData, 'pathname:', window.location.pathname )

  // Use loader data when available, otherwise fall back to an empty array
  const cardsData = loaderData || []

  const handleCardClick = ( title ) => {
    // if ( title === 'Supply Planning' )
    //   navigate( '/supply-planning' )
    // else if ( title === 'Inventory Optimization' )
    //   navigate( '/inventory-optimization' )
  };

  return (
    <div className="landing-content">
      <div className="Landing-main">
        {/* <h3 style={{ marginBottom: "2rem", fontWeight: "normal", fontSize: "1.25rem" }}>Select the app to launch</h3> */ }
        <Grid container className="landing_cards_cls">
          { cardsData?.map( ( data ) => {
            return (
              <Grid key={ data.id } size={ { xs: 4 } }>
                <LandingCard
                  title={ data.title }
                  appCode={ data.appCode }
                  url={ data.url }
                  className={ data.className }
                  disabled={ data.disabled }
                  onClick={ () => handleCardClick( data.title ) }
                />
              </Grid>
            );
          } ) }
        </Grid>
      </div>
    </div>
  );
};

export default LandingPage;
